(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["esr-cart-visibility"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.esrCartVisibilityReady) return;
  window.esrCartVisibilityReady = true;
  const mobile = window.matchMedia('(max-width:767px)');
  const upsellSelector = '#esr-chassis40-up,#esr-ax160-up,#esr-ax80-up';
  const visible = element => !!element && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
  const mainButton = () => Array.from(document.querySelectorAll('gp-product-button button[name="add"],form[action*="/cart/add"] button[name="add"]')).find(element => !element.closest('#qikify-stickycart-v2-app') && visible(element));
  const selectedExtras = root => !!root.querySelector('input:checked:not(:disabled):not([value="none"]):not([value=""])');
  let queued = false;
  function update() {
    queued = false;
    const button = mainButton();
    const header = document.querySelector('[data-esr-premium-header]');
    const headerBottom = Math.max(0, header?.getBoundingClientRect().bottom || 0);
    const upsells = Array.from(document.querySelectorAll(upsellSelector)).filter(visible);
    const selecting = upsells.some(root => {
      const rect = root.getBoundingClientRect();
      return selectedExtras(root) || (rect.bottom > headerBottom && rect.top < window.innerHeight);
    });
    const drawer = document.querySelector('.qsc2-drawer:not(.qsc2-drawer--hidden)');
    const editing = document.activeElement?.matches('input:not([type="radio"]):not([type="checkbox"]),textarea,select');
    const allowed = mobile.matches && button && button.getBoundingClientRect().bottom < headerBottom
      && !button.disabled && button.getAttribute('aria-disabled') !== 'true'
      && button.dataset.state !== 'loading' && !selecting && !visible(drawer)
      && !header?.hasAttribute('data-menu-open') && !editing;
    document.documentElement.classList.toggle('esr-mobile-buy-visible', !!allowed);
    if (allowed) {
      const label = button.querySelector('.gp-content-product-button');
      const stickyLabel = document.querySelector('.qsc2-stickybar__action-label');
      const stickyButton = document.querySelector('.qsc2-stickybar__action-btn');
      if (label && stickyLabel && label.textContent.trim() !== stickyLabel.textContent.trim()) {
        stickyLabel.textContent = label.textContent.trim();
        stickyButton?.setAttribute('aria-label', label.textContent.trim());
      }
      const source = document.querySelector('gp-product-price:not(.gp-button-price) .gp-price.gp-money');
      const target = document.querySelector('.qsc2-stickybar__product-price');
      if (source && target && source.textContent.trim() !== target.textContent.trim()) target.textContent = source.textContent.trim();
    }
  }
  function schedule() {
    if (!queued) { queued = true; requestAnimationFrame(update); }
  }
  document.addEventListener('click', event => {
    if (!event.target.closest('.qsc2-stickybar__action-btn')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const selected = Array.from(document.querySelectorAll(upsellSelector)).find(selectedExtras);
    const button = selected ? selected.querySelector('#ax-add') : mainButton();
    if (button && !button.disabled) button.click();
    schedule();
  }, true);
  window.addEventListener('scroll', schedule, {passive:true});
  window.addEventListener('resize', schedule, {passive:true});
  document.addEventListener('change', schedule);
  document.addEventListener('focusin', schedule);
  document.addEventListener('focusout', schedule);
  mobile.addEventListener('change', schedule);
  setInterval(() => { if (!document.hidden) update(); }, 750);
  update();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["esr-premium-footer"] && !Shopify.designMode) return;
  try {
    (() => {
 function init(root) {
  if (!root || root.dataset.ready) return;
  root.dataset.ready='true';
  const groups=Array.from(root.querySelectorAll('.esr-footer__group'));
  const wide=window.matchMedia('(min-width:990px)');
  const controller=new AbortController();
  const sync=()=>groups.forEach(group=>group.open=wide.matches);
  sync();
  wide.addEventListener('change',sync,{signal:controller.signal});
  groups.forEach(group=>group.querySelector('summary').addEventListener('click',event=>{if(wide.matches)event.preventDefault();},{signal:controller.signal}));
  document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(root))controller.abort();},{signal:controller.signal});
 }
 document.querySelectorAll('[data-esr-footer]').forEach(init);
 document.addEventListener('shopify:section:load',event=>init(event.target.querySelector('[data-esr-footer]')));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["esr-premium-header"] && !Shopify.designMode) return;
  try {
    (() => {
  function init(root) {
    if (!root || root.dataset.enhanced) return;
    const toggle = root.querySelector('[data-esr-toggle]');
    const navigation = root.querySelector('.esr-nav__navigation');
    const groups = Array.from(root.querySelectorAll('.esr-nav__details'));
    const desktop = window.matchMedia('(min-width: 990px)');
    const controller = new AbortController();
    const signal = controller.signal;
    root.dataset.enhanced = 'true';
    function closeMenu(restore) {
      root.removeAttribute('data-menu-open');
      toggle.setAttribute('aria-expanded', 'false');
      groups.forEach(group => group.open = false);
      if (restore) toggle.focus();
    }
    toggle.addEventListener('click', () => {
      const open = !root.hasAttribute('data-menu-open');
      root.toggleAttribute('data-menu-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      if (!open) groups.forEach(group => group.open = false);
    }, {signal});
    groups.forEach(group => group.addEventListener('toggle', () => {
      if (group.open) groups.forEach(other => { if (other !== group) other.open = false; });
    }, {signal}));
    root.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const open = groups.find(group => group.open);
      if (open) { open.open = false; open.querySelector('summary').focus(); }
      else if (!desktop.matches && root.hasAttribute('data-menu-open')) closeMenu(true);
    }, {signal});
    document.addEventListener('click', event => { if (!root.contains(event.target)) closeMenu(false); }, {signal});
    root.addEventListener('focusout', event => { if (event.relatedTarget && !root.contains(event.relatedTarget)) closeMenu(false); }, {signal});
    desktop.addEventListener('change', () => closeMenu(false), {signal});
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) controller.abort();
    }, {signal});
  }
  document.querySelectorAll('[data-esr-premium-header]').forEach(init);
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('[data-esr-premium-header]')));
})();
  } catch(e) { console.error(e); }
})();

})();
